module.exports = __webpack_public_path__ + "img/edit-dollar-active.20b01e59.svg";